<template>
  <div id="applications_wrapper">
    <p class="subtitle">Download aplikasi <b>SOCO by Sociolla</b> yang tersedia di iOS dan Android.</p>
    <div class="apps_wrapper">
      <a href="https://apps.apple.com/id/app/soco-by-sociolla/id1451280877" target="_blank" rel="noopener noreferrer">
        <SvgImg name="ios_apps" width="93" height="31" alt="Sociolla ios app icon" />
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=com.socialbella.soco"
        target="_blank"
        rel="noopener noreferrer"
      >
        <SvgImg name="google_play_apps" width="105" height="31" alt="Sociolla ios app icon" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'application-wrapper',
};
</script>

<style lang="scss" scoped>
#applications_wrapper {
  .subtitle {
    font: 13px/21px 'Lato', sans-serif;
    color: #333333;
    margin: 0;
  }
  .apps_wrapper {
    display: flex;
    align-items: center;
    margin: 17px 0 0;
    svg:first-child {
      margin-right: 12px;
    }
  }
}
@media (max-width: 991px) {
  #applications_wrapper {
    .apps_wrapper {
      display: flex;
      justify-content: flex-start;
      margin-top: 16px;
      a {
        margin-right: 12px;
      }
      a:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
